import { useState } from 'react'
import { Phone, KeyRound, Loader2 } from 'lucide-react'
import useUserStore from '../stores/userStore'
import useSipStore from '../stores/sipStore'

export default function Login() {
  const loginWithToken = useUserStore(s => s.loginWithToken)
  const apiBase = useSipStore(s => s.config.apiBase || 'https://agent.kailai.tech')

  const [token, setToken] = useState('')
  const [name, setName] = useState('')
  const [extension, setExtension] = useState('')
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState(null)

  const handleLogin = async (e) => {
    e?.preventDefault()
    setErr(null)
    if (!token.trim()) return setErr('יש להזין טוקן עסק')
    if (!name.trim()) return setErr('יש להזין את שם הסוכן')

    setBusy(true)
    try {
      const res = await fetch(`${apiBase}/api/v1/auth/agent-login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Business-Token': token.trim() },
        body: JSON.stringify({ agent_name: name.trim(), preferred_extension: extension || undefined }),
      })
      const data = await res.json()
      if (!res.ok) {
        const msg = data?.error === 'all_extensions_busy' ? 'כל השלוחות תפוסות. נסה שוב בעוד כמה דקות.'
                  : data?.error === 'invalid token' ? 'טוקן עסק שגוי'
                  : data?.error === 'extension_not_yours_or_inactive' ? 'השלוחה הזו לא שייכת לעסק שלך'
                  : data?.error === 'account_suspended' ? 'החשבון מושעה. פנה למנהל המערכת.'
                  : data?.error || `שגיאה ${res.status}`
        throw new Error(msg)
      }
      loginWithToken(data, name)
    } catch (e) {
      setErr(e.message)
    } finally { setBusy(false) }
  }

  return (
    <div className="min-h-screen bg-bg flex items-center justify-center p-4">
      <div className="w-full max-w-sm bg-panel border border-line rounded-2xl p-6">
        <div className="text-center mb-6">
          <div className="w-14 h-14 mx-auto rounded-2xl bg-brand/20 flex items-center justify-center mb-3">
            <Phone size={24} className="text-brand" />
          </div>
          <h1 className="text-xl font-bold mb-1">KaliDialer</h1>
          <p className="text-sm text-mute">התחבר עם טוקן העסק שלך</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-4">
          <div>
            <label className="block text-mute text-xs mb-1">
              <KeyRound size={11} className="inline ms-1" />
              טוקן עסק
            </label>
            <input
              type="password"
              value={token}
              onChange={(e) => setToken(e.target.value)}
              placeholder="kd_..."
              className="w-full px-3 py-2 bg-bg border border-line rounded-lg ltr tech"
              autoFocus
            />
            <div className="text-[10px] text-mute mt-1">
              ניתן מהמנהל. כל סוכן בעסק משתמש באותו טוקן.
            </div>
          </div>

          <div>
            <label className="block text-mute text-xs mb-1">שם הסוכן</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="דוד כהן"
              className="w-full px-3 py-2 bg-bg border border-line rounded-lg"
            />
          </div>

          <div>
            <label className="block text-mute text-xs mb-1">שלוחה מועדפת <span className="opacity-60">(לא חובה)</span></label>
            <input
              type="text"
              value={extension}
              onChange={(e) => setExtension(e.target.value)}
              placeholder="1003"
              className="w-full px-3 py-2 bg-bg border border-line rounded-lg ltr tech"
            />
            <div className="text-[10px] text-mute mt-1">
              אם השדה ריק - תוקצה שלוחה זמינה אוטומטית.
            </div>
          </div>

          {err && <div className="bg-rose-500/10 border border-rose-500/40 rounded-lg p-2 text-sm text-rose-200">{err}</div>}

          <button
            type="submit"
            disabled={busy}
            className="w-full py-3 rounded-xl bg-brand hover:bg-brand/90 disabled:opacity-50 text-slate-900 font-bold flex items-center justify-center gap-2"
          >
            {busy ? <Loader2 size={16} className="animate-spin" /> : 'התחבר'}
          </button>
        </form>

        <div className="mt-6 text-[10px] text-mute text-center opacity-60">
          KaliDialer · WebRTC SIP softphone
        </div>
      </div>
    </div>
  )
}
